import { GET_SETTING } from "./actions";

const initialState = {
  getData: {},
  loading: true,
};

const settingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SETTING:
      return {
        ...state,
        getData: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default settingReducer;
